const formatSize = (unit, dpi, value) => {
  switch (unit) {
    case 'mm':
      return (value * 25.4 / dpi).toFixed(2)
    case 'inch':
      return (value / dpi).toFixed(2)
    default:
      return Math.round(value)
  }
}

export default formatSize



// WEBPACK FOOTER //
// ./src/utils/formatSize.js